module.exports = __webpack_public_path__ + "static/assets/ccfbf9a3edc4c5c792a2ae448d853e16.gif";